import { Link } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { ILoungeInfo } from "../../../../api/api";
import { isOpenShareState } from "../../../../atoms/atom";
import Share from "../../Share/Share";
import PageMobileBtn from "./PageMobileBtn";
import { useTranslation } from "react-i18next";
import PageCategory from "../pageLeft/pageMenu/PageCategory";

interface IProps {
  data: ILoungeInfo;
  getLikeBoard: () => void;
}

function PageMobileHeader(props: IProps) {
  const { t } = useTranslation();
  const { data, getLikeBoard } = props;
  const setIsOpenShare = useSetRecoilState(isOpenShareState);

  const handleShare = (e: React.MouseEvent) => {
    setIsOpenShare((isOpenShare) => !isOpenShare);
  };

  return (
    <div className="page-header">
      <div className="row-w clearfix">
        <img
          className="thumb-img"
          src={data?.data.top_thumb_image_url}
          alt={`${data?.data.service_code} thumb-img`}
        />
        <div className="header-cont">
          <span className="gamename clearfix">{data?.data.title}</span>
          <span className="btns-top f-right">
            <span className="share-box btns">
              <Link
                className="btns btn-share"
                to="#"
                onClick={(e) => handleShare(e)}
                title={t("share")}
              />
              <Share data={data} />
            </span>
          </span>
          <PageMobileBtn data={data} getLikeBoard={getLikeBoard} />
        </div>
      </div>
      <PageCategory />
    </div>
  );
}

export default PageMobileHeader;
